export default "__VITE_ASSET__KEIvG4uC__"